/*
  Project: Santa Clara Plating
  Author: xfive
 */

import HomeSlider from './modules/home-slider';
import SearchForm from './modules/search-form';
import GallerySlider from './modules/gallery-slider';
import ContactModal from './modules/contact-modal';
import MobileNav from './modules/mobile-nav';
import Tables from './modules/tables';

/* eslint-disable */

new HomeSlider();
new SearchForm();
new GallerySlider();
new ContactModal();
new MobileNav();
new Tables();



// WEBPACK FOOTER //
// ./src/scripts/app.js